import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { FloatingLoader } from '~/@common/ui/(Loader)/FloatingLoader'

import { useNaverWorksLogin } from './useNaverWorksLogin'

/**
 * 네이버 웍스(웨일 스페이스) 로그인 진입 페이지 (/whalespace).
 *
 * 두 가지 진입 경로를 모두 지원:
 * 1) `code` 쿼리를 들고 들어온 경우 → OAuth 콜백이므로 곧바로 서버 로그인 수행
 * 2) 쿼리 없이 진입한 경우 → 네이버 웍스 SSO authorize URL로 전체 페이지 이동
 *
 * ⚠️ /whalespace 경로는 외부 파트너사 시스템에 등록되어 있으므로 절대 변경 금지.
 * (구 앱의 네이티브앱 전용 분기는 통합 앱에서 네이티브 로그인이 제거되어 함께 제거됨)
 */
const LoginFromNaverWorksPage = () => {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code')
  const { authURI, login } = useNaverWorksLogin()

  useEffect(() => {
    if (code) {
      login(code)
      return
    }

    // code가 없으면 SSO authorize URL로 전체 페이지 이동 (클라이언트 라우팅 X)
    window.location.replace(authURI)
    // authURI는 매 렌더마다 새 state 값이 생성되므로 의존성에서 제외
    // (mount 시 한 번만 실행되는 의도를 명시)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])

  return <FloatingLoader />
}

export default LoginFromNaverWorksPage
